import React from "react";

const FontPairSelector = ({ activeFontPair, onFontPairChange, fontPairs }) => {
  return (
    <div className="font-pair-selector">
      {fontPairs.map((f) => (
        <button
          key={f.id}
          className={`font-pair-btn ${
            activeFontPair === f.id ? "active" : ""
          }`}
          onClick={() => onFontPairChange(f.id)}
          type="button"
          title={f.name}
        >
          <div className="font-preview-box">
            <span
              className="font-upper"
              style={{ fontFamily: `"${f.heading}", sans-serif` }}
            >
              Aa
            </span>
            <span
              className="font-lower"
              style={{ fontFamily: `"${f.body}", sans-serif` }}
            >
              Ab
            </span>
          </div>
          <div className="font-pair-info">
            <span className="font-heading" style={{ fontFamily: `"${f.heading}", sans-serif` }}>
              {f.heading.split(" ")[0]}
            </span>
            <span className="font-body" style={{ fontFamily: `"${f.body}", sans-serif` }}>
              {f.body.split(" ")[0]}
            </span>
          </div>
        </button>
      ))}
    </div>
  );
};

export default FontPairSelector;